import { Box, HStack, Pressable } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const MaxWidthFullHeight = Box.withConfig({
  flex: 1,
});

export const ServiceModeCategoryToggleWrapper = Box.withConfig({
  justifyContent: 'center',
  width: 'full',
});

export const ToggleButtonsWrapper = HStack.withConfig({
  borderRadius: 'sm',
  overflow: 'hidden',
  borderColor: theme.token('border-color-input'),
  borderWidth: 0.5,
  marginX: { base: '$4', md: 0 },
});

export const ToggleButton = Pressable.withConfig<{ selected: boolean }>(p => ({
  borderColor: theme.token('border-color-input'),
  borderWidth: 0.5,
  flex: '1',
  height: theme.token('height-input'),
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: p.selected ? theme.token('background-checked') : theme.token('background-input'),
  _web: {
    _hover: {
      borderColor: theme.token('border-color-hover'),
      cursor: 'pointer',
    },
  },
}));

export const ToggleButtonLabel = Box.withConfig<{ selected: boolean }>(p => ({
  _text: {
    color: p.selected ? theme.token('text-reversed') : theme.token('text-default'),
    font: theme.token('text-style-form-input'),
  },
}));

export const SearchContainer = Box.withConfig({
  marginTop: '$4',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});
